/*
 * Copyright (c) 2022.
 * ISNLab
 * Owner and rewriter: Sedov A. Sergey
 * sedov.sergey@isnlab.com
 */

import Qs from "qs";
import axios from "axios";
import {unAuth, gotError, notApproved, blocked, to404} from './storage'

axios.interceptors.response.use(function (response) {
        return response;
    },
    function (error) {
        if (error.response.status === 404) {
            to404()
        }
        if (error.response.status === 401) {
            unAuth(true)
        }
        if (error.response.status === 450) { //not approoved
            notApproved()
        }
        if (error.response.status === 460) { //blockerd
            blocked()
        }
        return Promise.reject(error);
    });

const host = process.env.NODE_ENV === 'development' ? 'http://aff.romance.ss' : ''

const apiPoints = {
    profile : host+'/partner/access/profile',
    login: host+"/partner/access/login",
    logout: host+"/partner/access/logout",
    balance: host+"/partner/details/balance",
    earnings: host+"/partner/details/earnings",
    withdraws: host+"/partner/details/withdraw-history",
    payment: host+"/partner/details/payment",
    limits: host+"/partner/settings/limits",
    defaults: host+"/partner/settings/defaults",
    offers: host+"/partner/settings/offers",
    countries: host+"/partner/settings/countries",
    offerlist: host+"/partner/settings/offer-list",
    postback: host+"/partner/settings/postback",
    tpostback: host+"/partner/settings/test-postback",
    withdraw: host+"/partner/advanced/withdraw",
    dashboard: host+"/partner/dashboard/index",
    singup: host+"/partner/access/signup",
    reset: host+"/partner/access/reset",
    creatives: host+"/partner/file/creatives",
    downCreatives: host+"/partner/file/download",
    streams: host+"/partner/dashboard/streams",
    pm: host+"/partner/advanced/payment-methods",
    frm: host+"/partner/access/frm",
};

function Request(point, config){
    const url = apiPoints[point] || null
    return new Promise((resolve, reject) => {
        //{ "Content-Type": "multipart/form-data" }
        if (config.method.toLowerCase() === 'post')
        {
            // config.data._csrf = yii.getCsrfToken();
            config.data = Qs.stringify(config.data);
        }
        config.url = url;

        axios(config)
            .then(resp => {
                resolve(resp)
            })
            .catch(err => {
                gotError(err)
                reject(err)
            })
    })
}

function RequestLocal(point, config)
{
    const url = apiPoints[point] || null
    if (config.method.toLowerCase() === 'post')
    {
        // config.data._csrf = yii.getCsrfToken();
        config.data = Qs.stringify(config.data);
    }
    config.url = url;

    return new Promise((resolve, reject) => {
        axios(config)
            .then(resp => {
                resolve(resp)
            })
            .catch(err => {
                reject(err)
            })
    })
}

async function getCsrf()
{
   let data = await Request('frm', {method: 'POST'})
   return data.data.code
}

export {
    Request,
    RequestLocal,
    getCsrf,
}